var map = {
	"./af": 40359,
	"./af.d": 14177,
	"./af.d.ts": 14177,
	"./af.js": 40359,
	"./ak": 71337,
	"./ak.d": 89712,
	"./ak.d.ts": 89712,
	"./ak.js": 71337,
	"./am": 47512,
	"./am.d": 25169,
	"./am.d.ts": 25169,
	"./am.js": 47512,
	"./an": 15289,
	"./an.d": 68980,
	"./an.d.ts": 68980,
	"./an.js": 15289,
	"./ar": 81723,
	"./ar.d": 45857,
	"./ar.d.ts": 45857,
	"./ar.js": 81723,
	"./ars": 4439,
	"./ars.d": 53707,
	"./ars.d.ts": 53707,
	"./ars.js": 4439,
	"./as": 60785,
	"./as.d": 3048,
	"./as.d.ts": 3048,
	"./as.js": 60785,
	"./asa": 54449,
	"./asa.d": 51351,
	"./asa.d.ts": 51351,
	"./asa.js": 54449,
	"./ast": 80614,
	"./ast.d": 43324,
	"./ast.d.ts": 43324,
	"./ast.js": 80614,
	"./az": 5873,
	"./az.d": 68541,
	"./az.d.ts": 68541,
	"./az.js": 5873,
	"./bal": 11408,
	"./bal.d": 56528,
	"./bal.d.ts": 56528,
	"./bal.js": 11408,
	"./be": 7362,
	"./be.d": 70146,
	"./be.d.ts": 70146,
	"./be.js": 7362,
	"./bem": 93361,
	"./bem.d": 29803,
	"./bem.d.ts": 29803,
	"./bem.js": 93361,
	"./bez": 86452,
	"./bez.d": 59927,
	"./bez.d.ts": 59927,
	"./bez.js": 86452,
	"./bg": 35556,
	"./bg.d": 74145,
	"./bg.d.ts": 74145,
	"./bg.js": 35556,
	"./bho": 85879,
	"./bho.d": 32513,
	"./bho.d.ts": 32513,
	"./bho.js": 85879,
	"./bm": 23189,
	"./bm.d": 77101,
	"./bm.d.ts": 77101,
	"./bm.js": 23189,
	"./bn": 17125,
	"./bn.d": 75827,
	"./bn.d.ts": 75827,
	"./bn.js": 17125,
	"./bo": 24765,
	"./bo.d": 72678,
	"./bo.d.ts": 72678,
	"./bo.js": 24765,
	"./br": 55605,
	"./br.d": 48899,
	"./br.d.ts": 48899,
	"./br.js": 55605,
	"./brx": 83097,
	"./brx.d": 12024,
	"./brx.d.ts": 12024,
	"./brx.js": 83097,
	"./bs": 35528,
	"./bs.d": 10215,
	"./bs.d.ts": 10215,
	"./bs.js": 35528,
	"./ca": 45078,
	"./ca.d": 13763,
	"./ca.d.ts": 13763,
	"./ca.js": 45078,
	"./ce": 44100,
	"./ce.d": 33641,
	"./ce.d.ts": 33641,
	"./ce.js": 44100,
	"./ceb": 48333,
	"./ceb.d": 38130,
	"./ceb.d.ts": 38130,
	"./ceb.js": 48333,
	"./cgg": 66268,
	"./cgg.d": 21555,
	"./cgg.d.ts": 21555,
	"./cgg.js": 66268,
	"./chr": 68288,
	"./chr.d": 16548,
	"./chr.d.ts": 16548,
	"./chr.js": 68288,
	"./ckb": 49966,
	"./ckb.d": 85222,
	"./ckb.d.ts": 85222,
	"./ckb.js": 49966,
	"./cs": 25690,
	"./cs.d": 35953,
	"./cs.d.ts": 35953,
	"./cs.js": 25690,
	"./cy": 48453,
	"./cy.d": 64985,
	"./cy.d.ts": 64985,
	"./cy.js": 48453,
	"./da": 85878,
	"./da.d": 93939,
	"./da.d.ts": 93939,
	"./da.js": 85878,
	"./de": 94452,
	"./de.d": 39886,
	"./de.d.ts": 39886,
	"./de.js": 94452,
	"./doi": 45932,
	"./doi.d": 13043,
	"./doi.d.ts": 13043,
	"./doi.js": 45932,
	"./dsb": 2619,
	"./dsb.d": 45278,
	"./dsb.d.ts": 45278,
	"./dsb.js": 2619,
	"./dv": 9360,
	"./dv.d": 55696,
	"./dv.d.ts": 55696,
	"./dv.js": 9360,
	"./dz": 17909,
	"./dz.d": 4903,
	"./dz.d.ts": 4903,
	"./dz.js": 17909,
	"./ee": 38026,
	"./ee.d": 69848,
	"./ee.d.ts": 69848,
	"./ee.js": 38026,
	"./el": 10843,
	"./el.d": 70838,
	"./el.d.ts": 70838,
	"./el.js": 10843,
	"./en": 42417,
	"./en.d": 27859,
	"./en.d.ts": 27859,
	"./en.js": 42417,
	"./eo": 8843,
	"./eo.d": 47683,
	"./eo.d.ts": 47683,
	"./eo.js": 8843,
	"./es": 81081,
	"./es.d": 89835,
	"./es.d.ts": 89835,
	"./es.js": 81081,
	"./et": 89830,
	"./et.d": 98829,
	"./et.d.ts": 98829,
	"./et.js": 89830,
	"./eu": 81421,
	"./eu.d": 77838,
	"./eu.d.ts": 77838,
	"./eu.js": 81421,
	"./fa": 44041,
	"./fa.d": 15515,
	"./fa.d.ts": 15515,
	"./fa.js": 44041,
	"./ff": 64074,
	"./ff.d": 10835,
	"./ff.d.ts": 10835,
	"./ff.js": 64074,
	"./fi": 82541,
	"./fi.d": 23480,
	"./fi.d.ts": 23480,
	"./fi.js": 82541,
	"./fil": 17074,
	"./fil.d": 34546,
	"./fil.d.ts": 34546,
	"./fil.js": 17074,
	"./fo": 87440,
	"./fo.d": 20091,
	"./fo.d.ts": 20091,
	"./fo.js": 87440,
	"./fr": 98961,
	"./fr.d": 57413,
	"./fr.d.ts": 57413,
	"./fr.js": 98961,
	"./fur": 46039,
	"./fur.d": 2843,
	"./fur.d.ts": 2843,
	"./fur.js": 46039,
	"./fy": 6616,
	"./fy.d": 74864,
	"./fy.d.ts": 74864,
	"./fy.js": 6616,
	"./ga": 91056,
	"./ga.d": 88826,
	"./ga.d.ts": 88826,
	"./ga.js": 91056,
	"./gd": 18895,
	"./gd.d": 17750,
	"./gd.d.ts": 17750,
	"./gd.js": 18895,
	"./gl": 79982,
	"./gl.d": 29902,
	"./gl.d.ts": 29902,
	"./gl.js": 79982,
	"./gsw": 82366,
	"./gsw.d": 73856,
	"./gsw.d.ts": 73856,
	"./gsw.js": 82366,
	"./gu": 62473,
	"./gu.d": 44721,
	"./gu.d.ts": 44721,
	"./gu.js": 62473,
	"./guw": 23710,
	"./guw.d": 90638,
	"./guw.d.ts": 90638,
	"./guw.js": 23710,
	"./gv": 87328,
	"./gv.d": 4405,
	"./gv.d.ts": 4405,
	"./gv.js": 87328,
	"./ha": 26294,
	"./ha.d": 43924,
	"./ha.d.ts": 43924,
	"./ha.js": 26294,
	"./haw": 50002,
	"./haw.d": 63271,
	"./haw.d.ts": 63271,
	"./haw.js": 50002,
	"./he": 54012,
	"./he.d": 19439,
	"./he.d.ts": 19439,
	"./he.js": 54012,
	"./hi": 84390,
	"./hi.d": 48068,
	"./hi.d.ts": 48068,
	"./hi.js": 84390,
	"./hnj": 23359,
	"./hnj.d": 31312,
	"./hnj.d.ts": 31312,
	"./hnj.js": 23359,
	"./hr": 47342,
	"./hr.d": 82719,
	"./hr.d.ts": 82719,
	"./hr.js": 47342,
	"./hsb": 26813,
	"./hsb.d": 92330,
	"./hsb.d.ts": 92330,
	"./hsb.js": 26813,
	"./hu": 69864,
	"./hu.d": 47722,
	"./hu.d.ts": 47722,
	"./hu.js": 69864,
	"./hy": 72623,
	"./hy.d": 45455,
	"./hy.d.ts": 45455,
	"./hy.js": 72623,
	"./ia": 47261,
	"./ia.d": 21023,
	"./ia.d.ts": 21023,
	"./ia.js": 47261,
	"./id": 22030,
	"./id.d": 93241,
	"./id.d.ts": 93241,
	"./id.js": 22030,
	"./ig": 5491,
	"./ig.d": 95592,
	"./ig.d.ts": 95592,
	"./ig.js": 5491,
	"./ii": 39854,
	"./ii.d": 86157,
	"./ii.d.ts": 86157,
	"./ii.js": 39854,
	"./io": 71391,
	"./io.d": 72471,
	"./io.d.ts": 72471,
	"./io.js": 71391,
	"./is": 52451,
	"./is.d": 60712,
	"./is.d.ts": 60712,
	"./is.js": 52451,
	"./it": 72461,
	"./it.d": 31273,
	"./it.d.ts": 31273,
	"./it.js": 72461,
	"./iu": 80572,
	"./iu.d": 8278,
	"./iu.d.ts": 8278,
	"./iu.js": 80572,
	"./ja": 5125,
	"./ja.d": 37435,
	"./ja.d.ts": 37435,
	"./ja.js": 5125,
	"./jbo": 90712,
	"./jbo.d": 21473,
	"./jbo.d.ts": 21473,
	"./jbo.js": 90712,
	"./jgo": 41662,
	"./jgo.d": 11172,
	"./jgo.d.ts": 11172,
	"./jgo.js": 41662,
	"./jmc": 5340,
	"./jmc.d": 98758,
	"./jmc.d.ts": 98758,
	"./jmc.js": 5340,
	"./jv": 93736,
	"./jv.d": 30358,
	"./jv.d.ts": 30358,
	"./jv.js": 93736,
	"./jw": 68003,
	"./jw.d": 47186,
	"./jw.d.ts": 47186,
	"./jw.js": 68003,
	"./ka": 47373,
	"./ka.d": 70584,
	"./ka.d.ts": 70584,
	"./ka.js": 47373,
	"./kab": 12705,
	"./kab.d": 26301,
	"./kab.d.ts": 26301,
	"./kab.js": 12705,
	"./kaj": 45622,
	"./kaj.d": 78674,
	"./kaj.d.ts": 78674,
	"./kaj.js": 45622,
	"./kcg": 81239,
	"./kcg.d": 53643,
	"./kcg.d.ts": 53643,
	"./kcg.js": 81239,
	"./kde": 64492,
	"./kde.d": 47876,
	"./kde.d.ts": 47876,
	"./kde.js": 64492,
	"./kea": 66447,
	"./kea.d": 50018,
	"./kea.d.ts": 50018,
	"./kea.js": 66447,
	"./kk": 6270,
	"./kk.d": 86780,
	"./kk.d.ts": 86780,
	"./kk.js": 6270,
	"./kkj": 17324,
	"./kkj.d": 1700,
	"./kkj.d.ts": 1700,
	"./kkj.js": 17324,
	"./kl": 83658,
	"./kl.d": 18202,
	"./kl.d.ts": 18202,
	"./kl.js": 83658,
	"./km": 56658,
	"./km.d": 38183,
	"./km.d.ts": 38183,
	"./km.js": 56658,
	"./kn": 38331,
	"./kn.d": 90491,
	"./kn.d.ts": 90491,
	"./kn.js": 38331,
	"./ko": 26724,
	"./ko.d": 49583,
	"./ko.d.ts": 49583,
	"./ko.js": 26724,
	"./ks": 21812,
	"./ks.d": 70710,
	"./ks.d.ts": 70710,
	"./ks.js": 21812,
	"./ksb": 51586,
	"./ksb.d": 80659,
	"./ksb.d.ts": 80659,
	"./ksb.js": 51586,
	"./ksh": 65953,
	"./ksh.d": 35754,
	"./ksh.d.ts": 35754,
	"./ksh.js": 65953,
	"./ku": 15263,
	"./ku.d": 41462,
	"./ku.d.ts": 41462,
	"./ku.js": 15263,
	"./kw": 91037,
	"./kw.d": 15490,
	"./kw.d.ts": 15490,
	"./kw.js": 91037,
	"./ky": 44524,
	"./ky.d": 24933,
	"./ky.d.ts": 24933,
	"./ky.js": 44524,
	"./lag": 90164,
	"./lag.d": 22047,
	"./lag.d.ts": 22047,
	"./lag.js": 90164,
	"./lb": 70713,
	"./lb.d": 96439,
	"./lb.d.ts": 96439,
	"./lb.js": 70713,
	"./lg": 28801,
	"./lg.d": 2776,
	"./lg.d.ts": 2776,
	"./lg.js": 28801,
	"./lij": 16148,
	"./lij.d": 7085,
	"./lij.d.ts": 7085,
	"./lij.js": 16148,
	"./lkt": 31773,
	"./lkt.d": 922,
	"./lkt.d.ts": 922,
	"./lkt.js": 31773,
	"./ln": 50242,
	"./ln.d": 80719,
	"./ln.d.ts": 80719,
	"./ln.js": 50242,
	"./lo": 42234,
	"./lo.d": 9384,
	"./lo.d.ts": 9384,
	"./lo.js": 42234,
	"./lt": 94179,
	"./lt.d": 47343,
	"./lt.d.ts": 47343,
	"./lt.js": 94179,
	"./lv": 74250,
	"./lv.d": 39817,
	"./lv.d.ts": 39817,
	"./lv.js": 74250,
	"./mas": 14428,
	"./mas.d": 21534,
	"./mas.d.ts": 21534,
	"./mas.js": 14428,
	"./mg": 38440,
	"./mg.d": 57154,
	"./mg.d.ts": 57154,
	"./mg.js": 38440,
	"./mgo": 39394,
	"./mgo.d": 5855,
	"./mgo.d.ts": 5855,
	"./mgo.js": 39394,
	"./mk": 49085,
	"./mk.d": 80392,
	"./mk.d.ts": 80392,
	"./mk.js": 49085,
	"./ml": 69643,
	"./ml.d": 88122,
	"./ml.d.ts": 88122,
	"./ml.js": 69643,
	"./mn": 36310,
	"./mn.d": 54695,
	"./mn.d.ts": 54695,
	"./mn.js": 36310,
	"./mo": 71257,
	"./mo.d": 90243,
	"./mo.d.ts": 90243,
	"./mo.js": 71257,
	"./mr": 9693,
	"./mr.d": 48331,
	"./mr.d.ts": 48331,
	"./mr.js": 9693,
	"./ms": 71761,
	"./ms.d": 31181,
	"./ms.d.ts": 31181,
	"./ms.js": 71761,
	"./mt": 60681,
	"./mt.d": 9595,
	"./mt.d.ts": 9595,
	"./mt.js": 60681,
	"./my": 34093,
	"./my.d": 86915,
	"./my.d.ts": 86915,
	"./my.js": 34093,
	"./nah": 10123,
	"./nah.d": 81549,
	"./nah.d.ts": 81549,
	"./nah.js": 10123,
	"./naq": 87361,
	"./naq.d": 18133,
	"./naq.d.ts": 18133,
	"./naq.js": 87361,
	"./nb": 57696,
	"./nb.d": 42792,
	"./nb.d.ts": 42792,
	"./nb.js": 57696,
	"./nd": 97401,
	"./nd.d": 71315,
	"./nd.d.ts": 71315,
	"./nd.js": 97401,
	"./ne": 55240,
	"./ne.d": 64970,
	"./ne.d.ts": 64970,
	"./ne.js": 55240,
	"./nl": 24976,
	"./nl.d": 10370,
	"./nl.d.ts": 10370,
	"./nl.js": 24976,
	"./nn": 94699,
	"./nn.d": 96896,
	"./nn.d.ts": 96896,
	"./nn.js": 94699,
	"./nnh": 28908,
	"./nnh.d": 69559,
	"./nnh.d.ts": 69559,
	"./nnh.js": 28908,
	"./no": 61773,
	"./no.d": 90722,
	"./no.d.ts": 90722,
	"./no.js": 61773,
	"./nqo": 30906,
	"./nqo.d": 62767,
	"./nqo.d.ts": 62767,
	"./nqo.js": 30906,
	"./nr": 47997,
	"./nr.d": 55630,
	"./nr.d.ts": 55630,
	"./nr.js": 47997,
	"./nso": 82515,
	"./nso.d": 80588,
	"./nso.d.ts": 80588,
	"./nso.js": 82515,
	"./ny": 7342,
	"./ny.d": 63374,
	"./ny.d.ts": 63374,
	"./ny.js": 7342,
	"./nyn": 11487,
	"./nyn.d": 51884,
	"./nyn.d.ts": 51884,
	"./nyn.js": 11487,
	"./om": 63122,
	"./om.d": 66232,
	"./om.d.ts": 66232,
	"./om.js": 63122,
	"./or": 70499,
	"./or.d": 41337,
	"./or.d.ts": 41337,
	"./or.js": 70499,
	"./os": 82813,
	"./os.d": 55655,
	"./os.d.ts": 55655,
	"./os.js": 82813,
	"./osa": 9306,
	"./osa.d": 95009,
	"./osa.d.ts": 95009,
	"./osa.js": 9306,
	"./pa": 5012,
	"./pa.d": 91922,
	"./pa.d.ts": 91922,
	"./pa.js": 5012,
	"./pap": 19608,
	"./pap.d": 24151,
	"./pap.d.ts": 24151,
	"./pap.js": 19608,
	"./pcm": 72374,
	"./pcm.d": 32306,
	"./pcm.d.ts": 32306,
	"./pcm.js": 72374,
	"./pl": 2050,
	"./pl.d": 63913,
	"./pl.d.ts": 63913,
	"./pl.js": 2050,
	"./prg": 51409,
	"./prg.d": 51034,
	"./prg.d.ts": 51034,
	"./prg.js": 51409,
	"./ps": 65180,
	"./ps.d": 49078,
	"./ps.d.ts": 49078,
	"./ps.js": 65180,
	"./pt": 10078,
	"./pt-PT": 36512,
	"./pt-PT.d": 80813,
	"./pt-PT.d.ts": 80813,
	"./pt-PT.js": 36512,
	"./pt.d": 94289,
	"./pt.d.ts": 94289,
	"./pt.js": 10078,
	"./rm": 66444,
	"./rm.d": 37551,
	"./rm.d.ts": 37551,
	"./rm.js": 66444,
	"./ro": 76553,
	"./ro.d": 23546,
	"./ro.d.ts": 23546,
	"./ro.js": 76553,
	"./rof": 35261,
	"./rof.d": 88054,
	"./rof.d.ts": 88054,
	"./rof.js": 35261,
	"./ru": 51182,
	"./ru.d": 3195,
	"./ru.d.ts": 3195,
	"./ru.js": 51182,
	"./rwk": 88085,
	"./rwk.d": 72502,
	"./rwk.d.ts": 72502,
	"./rwk.js": 88085,
	"./sah": 69199,
	"./sah.d": 79607,
	"./sah.d.ts": 79607,
	"./sah.js": 69199,
	"./saq": 94229,
	"./saq.d": 61103,
	"./saq.d.ts": 61103,
	"./saq.js": 94229,
	"./sat": 4527,
	"./sat.d": 91986,
	"./sat.d.ts": 91986,
	"./sat.js": 4527,
	"./sc": 18535,
	"./sc.d": 31759,
	"./sc.d.ts": 31759,
	"./sc.js": 18535,
	"./scn": 65712,
	"./scn.d": 32181,
	"./scn.d.ts": 32181,
	"./scn.js": 65712,
	"./sd": 72232,
	"./sd.d": 20921,
	"./sd.d.ts": 20921,
	"./sd.js": 72232,
	"./sdh": 10006,
	"./sdh.d": 87476,
	"./sdh.d.ts": 87476,
	"./sdh.js": 10006,
	"./se": 90934,
	"./se.d": 1620,
	"./se.d.ts": 1620,
	"./se.js": 90934,
	"./seh": 33396,
	"./seh.d": 4181,
	"./seh.d.ts": 4181,
	"./seh.js": 33396,
	"./ses": 92236,
	"./ses.d": 34517,
	"./ses.d.ts": 34517,
	"./ses.js": 92236,
	"./sg": 89361,
	"./sg.d": 84764,
	"./sg.d.ts": 84764,
	"./sg.js": 89361,
	"./sh": 26814,
	"./sh.d": 30362,
	"./sh.d.ts": 30362,
	"./sh.js": 26814,
	"./shi": 6793,
	"./shi.d": 71459,
	"./shi.d.ts": 71459,
	"./shi.js": 6793,
	"./si": 71114,
	"./si.d": 96870,
	"./si.d.ts": 96870,
	"./si.js": 71114,
	"./sk": 173,
	"./sk.d": 77522,
	"./sk.d.ts": 77522,
	"./sk.js": 173,
	"./sl": 9394,
	"./sl.d": 66237,
	"./sl.d.ts": 66237,
	"./sl.js": 9394,
	"./sma": 31258,
	"./sma.d": 30764,
	"./sma.d.ts": 30764,
	"./sma.js": 31258,
	"./smi": 58292,
	"./smi.d": 76707,
	"./smi.d.ts": 76707,
	"./smi.js": 58292,
	"./smj": 4491,
	"./smj.d": 48059,
	"./smj.d.ts": 48059,
	"./smj.js": 4491,
	"./smn": 97882,
	"./smn.d": 15764,
	"./smn.d.ts": 15764,
	"./smn.js": 97882,
	"./sms": 56471,
	"./sms.d": 75505,
	"./sms.d.ts": 75505,
	"./sms.js": 56471,
	"./sn": 95270,
	"./sn.d": 53627,
	"./sn.d.ts": 53627,
	"./sn.js": 95270,
	"./so": 13654,
	"./so.d": 15274,
	"./so.d.ts": 15274,
	"./so.js": 13654,
	"./sq": 15632,
	"./sq.d": 58630,
	"./sq.d.ts": 58630,
	"./sq.js": 15632,
	"./sr": 54151,
	"./sr.d": 37763,
	"./sr.d.ts": 37763,
	"./sr.js": 54151,
	"./ss": 11912,
	"./ss.d": 53892,
	"./ss.d.ts": 53892,
	"./ss.js": 11912,
	"./ssy": 94236,
	"./ssy.d": 86500,
	"./ssy.d.ts": 86500,
	"./ssy.js": 94236,
	"./st": 55034,
	"./st.d": 74710,
	"./st.d.ts": 74710,
	"./st.js": 55034,
	"./su": 44488,
	"./su.d": 22686,
	"./su.d.ts": 22686,
	"./su.js": 44488,
	"./sv": 16293,
	"./sv.d": 30099,
	"./sv.d.ts": 30099,
	"./sv.js": 16293,
	"./sw": 66159,
	"./sw.d": 75196,
	"./sw.d.ts": 75196,
	"./sw.js": 66159,
	"./syr": 63068,
	"./syr.d": 62592,
	"./syr.d.ts": 62592,
	"./syr.js": 63068,
	"./ta": 74966,
	"./ta.d": 78005,
	"./ta.d.ts": 78005,
	"./ta.js": 74966,
	"./te": 54437,
	"./te.d": 33066,
	"./te.d.ts": 33066,
	"./te.js": 54437,
	"./teo": 57561,
	"./teo.d": 62554,
	"./teo.d.ts": 62554,
	"./teo.js": 57561,
	"./th": 11665,
	"./th.d": 50835,
	"./th.d.ts": 50835,
	"./th.js": 11665,
	"./ti": 68028,
	"./ti.d": 5587,
	"./ti.d.ts": 5587,
	"./ti.js": 68028,
	"./tig": 25398,
	"./tig.d": 60507,
	"./tig.d.ts": 60507,
	"./tig.js": 25398,
	"./tk": 16254,
	"./tk.d": 29771,
	"./tk.d.ts": 29771,
	"./tk.js": 16254,
	"./tl": 14728,
	"./tl.d": 42487,
	"./tl.d.ts": 42487,
	"./tl.js": 14728,
	"./tn": 14169,
	"./tn.d": 60624,
	"./tn.d.ts": 60624,
	"./tn.js": 14169,
	"./to": 62144,
	"./to.d": 387,
	"./to.d.ts": 387,
	"./to.js": 62144,
	"./tpi": 87237,
	"./tpi.d": 82778,
	"./tpi.d.ts": 82778,
	"./tpi.js": 87237,
	"./tr": 95624,
	"./tr.d": 25005,
	"./tr.d.ts": 25005,
	"./tr.js": 95624,
	"./ts": 62546,
	"./ts.d": 48210,
	"./ts.d.ts": 48210,
	"./ts.js": 62546,
	"./tzm": 37289,
	"./tzm.d": 25549,
	"./tzm.d.ts": 25549,
	"./tzm.js": 37289,
	"./ug": 37138,
	"./ug.d": 56980,
	"./ug.d.ts": 56980,
	"./ug.js": 37138,
	"./uk": 30238,
	"./uk.d": 32124,
	"./uk.d.ts": 32124,
	"./uk.js": 30238,
	"./und": 37376,
	"./und.d": 54378,
	"./und.d.ts": 54378,
	"./und.js": 37376,
	"./ur": 90561,
	"./ur.d": 57978,
	"./ur.d.ts": 57978,
	"./ur.js": 90561,
	"./uz": 96266,
	"./uz.d": 29875,
	"./uz.d.ts": 29875,
	"./uz.js": 96266,
	"./ve": 21301,
	"./ve.d": 41177,
	"./ve.d.ts": 41177,
	"./ve.js": 21301,
	"./vi": 46652,
	"./vi.d": 42255,
	"./vi.d.ts": 42255,
	"./vi.js": 46652,
	"./vo": 98666,
	"./vo.d": 28458,
	"./vo.d.ts": 28458,
	"./vo.js": 98666,
	"./vun": 2530,
	"./vun.d": 31891,
	"./vun.d.ts": 31891,
	"./vun.js": 2530,
	"./wa": 38502,
	"./wa.d": 98477,
	"./wa.d.ts": 98477,
	"./wa.js": 38502,
	"./wae": 12220,
	"./wae.d": 87639,
	"./wae.d.ts": 87639,
	"./wae.js": 12220,
	"./wo": 89207,
	"./wo.d": 31740,
	"./wo.d.ts": 31740,
	"./wo.js": 89207,
	"./xh": 10744,
	"./xh.d": 93588,
	"./xh.d.ts": 93588,
	"./xh.js": 10744,
	"./xog": 64082,
	"./xog.d": 94981,
	"./xog.d.ts": 94981,
	"./xog.js": 64082,
	"./yi": 62134,
	"./yi.d": 50836,
	"./yi.d.ts": 50836,
	"./yi.js": 62134,
	"./yo": 60616,
	"./yo.d": 7472,
	"./yo.d.ts": 7472,
	"./yo.js": 60616,
	"./yue": 57451,
	"./yue.d": 87624,
	"./yue.d.ts": 87624,
	"./yue.js": 57451,
	"./zh": 40413,
	"./zh.d": 80966,
	"./zh.d.ts": 80966,
	"./zh.js": 40413,
	"./zu": 71930,
	"./zu.d": 3531,
	"./zu.d.ts": 3531,
	"./zu.js": 71930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80740;